import { reviewBodySchema } from "@redotech/redo-model/review/review-body-schema";
import { z } from "zod";

export const getReviewById = {
  input: z.object({ reviewId: z.string(), email: z.string().email() }),
  output: reviewBodySchema.nullable(),
};
